// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = require("!!../../../../node_modules/css-loader/index.js?minimize!../../../../node_modules/sass-loader/lib/loader.js!./SlideImage2.l.scss");

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-to-string-loader!./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/SlideImage2/SlideImage2.l.scss
// module id = 1105
// module chunks = 19